import React from "react";
import styles from "./ReportKpiGrid.module.scss";

interface ReportKpiGridProps {
  /** Bir satırda hedeflenen sütun sayısı. Responsive olarak küçülür. */
  columns?: 2 | 3 | 4 | 5;
  children: React.ReactNode;
}

/**
 * Rapor KPI kartlarını tutarlı bir şekilde yerleştiren responsive grid.
 */
const ReportKpiGrid: React.FC<ReportKpiGridProps> = ({
  columns = 4,
  children,
}) => {
  return (
    <div
      className={styles.grid}
      data-columns={columns}
    >
      {children}
    </div>
  );
};

export default ReportKpiGrid;
